/**
 * @file: 商品组件通信
 * @author: xiaolong.huang@dmall.com
 */

import { StageEvent } from '../../../message/index';
import * as CubeTree from '../../../cubeTree/index';
import * as GoodsRenderCore from '../renderCore/index';

function init(cube: CubeNode): void {
    // 隔板和文本框不用监听以下事件
    if (CubeTree.isTextarea(cube.id) || CubeTree.isBafflePlate(cube.id)) {
        return;
    }

    StageEvent.on(['changeRenderMode', 'tagsChangeSetting'], (): void => {
        // 商品渲染状态切换
        GoodsRenderCore.statusSwitch(cube);
    }, null, cube.id);

    StageEvent.on(['changeSetting'], (): void => {
        // 主商品文字渲染
        GoodsRenderCore.mainGoodsTxt(cube);

        // 字码商品文字渲染
        GoodsRenderCore.subGoodsTxt(cube);
    }, null, cube.id);
}

function unbind(cube: CubeNode): void {
    StageEvent.unbind(['changeRenderMode', 'tagsChangeSetting', 'changeSetting'], cube.id);
}

export default {
    init,
    unbind
};
